// extracted by mini-css-extract-plugin
module.exports = {"errorOverlay":"Layout_errorOverlay__2-4PZ","errorModal":"Layout_errorModal__23U0v","errorText":"Layout_errorText__1Qdct","errorButton":"Layout_errorButton__1vhG_"};